import { jsonldIngredient } from './JsonldStore';

export const updateJsonldIngredient = (value) => jsonldIngredient.update((oldValue) => value);
